import { render } from "./LeadCreate.vue?vue&type=template&id=02cbf431&scoped=true"
import script from "./LeadCreate.vue?vue&type=script&lang=js"
export * from "./LeadCreate.vue?vue&type=script&lang=js"

import "./LeadCreate.vue?vue&type=style&index=0&id=02cbf431&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cbf431"]])

export default __exports__